/**
 * Return element style to make it screen reader only
 */

export const getScreenReaderOnlyStyle = () => ({
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: '0',
  clipPath: 'inset(50%)'
});